import { API_BASE_URL, endpoints } from "./config";
import { authHeadersForGet, authHeadersJson } from "./http";
import { Product, CreateProductDto } from "../types/product";
import { CreateProductVariantDto } from "../types/product";

export interface ProductSearchParams {
  search?: string;
  categoryReference?: string;
  brandReference?: string;
  page?: number;
  limit?: number;
}

export interface ProductsResponse {
  data: Product[];
  total: number;
  page: number;
  lastPage: number;
}

export const productsApi = {
  getAll: async (
    page: number = 1,
    limit: number = 10
  ): Promise<ProductsResponse> => {
    const response = await fetch(
      `${API_BASE_URL}/products?page=${page}&limit=${limit}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  search: async (params?: ProductSearchParams): Promise<ProductsResponse> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.products.search(params)}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  getOne: async (reference: string): Promise<Product> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.products.getOne(reference)}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  create: async (product: CreateProductDto): Promise<Product> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.products.create}`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(product),
      }
    );
    return response.json();
  },

  createBulk: async (
    products: CreateProductDto[]
  ): Promise<{ success: Product[]; errors: any[] }> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.products.createBulk}`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(products),
      }
    );
    return response.json();
  },

  update: async (
    reference: string,
    product: Partial<CreateProductDto>
  ): Promise<Product> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.products.update(reference)}`,
      {
        method: "PUT",
        headers: authHeadersJson(),
        body: JSON.stringify(product),
      }
    );
    return response.json();
  },

  createVariant: async (
    parentReference: string,
    variant: CreateProductVariantDto
  ): Promise<Product> => {
    const response = await fetch(
      `${API_BASE_URL}/products/${parentReference}/variants`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(variant),
      }
    );
    return response.json();
  },

  delete: async (reference: string): Promise<boolean> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.products.delete(reference)}`,
      {
        method: "DELETE",
        headers: authHeadersForGet(),
      }
    );
    return response.ok;
  },
};
